export { default } from './JobCard';
